// @ts-nocheck
/* eslint-disable */
export const chevronLeftIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.6069 1L12 2.47597L6.78617 8L12 13.524L10.6069 15L4 8L10.6069 1Z" fill="currentColor"/></svg>`,
    name: 'chevron-left' as const
};